const HALF_LUMINANCE = 255 / 2;

export function colorBrightness(hex:string = 'ffffff') {
    const color = hex.replace('#', '');
    const rgb = parseInt(color, 16);
    const red = (rgb >> 16) & 0xff;
    const green = (rgb >> 8) & 0xff;
    const blue = (rgb >> 0) & 0xff;
    const luma = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
    return luma;
}

export const hexToRGB = (hex: string): string => {
    let r = 0,
        g = 0,
        b = 0;
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }
    return `${r}, ${g}, ${b}`;
};

export function isColorBright(hex: string) {
    return colorBrightness(hex) > HALF_LUMINANCE;
}
